import ProvinciasFiltereMultiselect from './ProvinciasFilterMultiselect';
import type { Provincia } from './types';

export default ProvinciasFiltereMultiselect;
export type { Provincia };
